import { render, staticRenderFns } from "./flexibleSpec.vue?vue&type=template&id=1e6acbf6"
import script from "./flexibleSpec.vue?vue&type=script&lang=js"
export * from "./flexibleSpec.vue?vue&type=script&lang=js"
import style0 from "./flexibleSpec.vue?vue&type=style&index=0&id=1e6acbf6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports